
const Name = (cell) => {
    return cell.value ? cell.value : '';
};
const Address = (cell) => {
  return cell.value ? cell.value.split('\n').join(', ') : '';
}; 
const Phone = (cell) => {
    return cell.value ? cell.value : '';
};

const Email = cell => {
  return cell.value ? cell.value : ""
}

const Logo = (cell) => {
  return cell.value ? cell.value : '';
};

const Discount = (cell) => {
  return cell.value ? cell.value : 0;
};

const BannerImg = (cell) => {
  return cell.value ? cell.value : '';
};

const FacebookLink = (cell) => {
  return cell.value ? cell.value : '';
};

const InstagramLink = cell => {
  return cell.value ? cell.value : ""
}

const TwitterLink = cell => {
  return cell.value ? cell.value : ""
}

const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export {
  Address,
  Phone,
  Name,
  Email,
  IsActive,
  Logo,
  Discount,
  BannerImg,
  FacebookLink,
  InstagramLink,
  TwitterLink
}